<template>
    <v-app>
        <v-navigation-drawer
                class="nav-active-color drawercolor"
                width="200"
                v-model="drawer"
                app
                dark
        >
            <v-layout column fill-height justify-space-between>
                <v-flex>
                    <v-layout px-3 pt-4 column justify-start>
                        <v-flex xs12>
                            <img class="mb-2" src="@/assets/bindez-new-logo.png" height="55" width="55">
                            <template v-if="!isUserOrgLoading">
                                <h1 class="body-2 text-capitalize text-color">{{userOrganizationName}}</h1>
                                <p class="caption" style="color:#8A93A0;">Expired: {{userOrganizationExipresDate}}</p>
                            </template>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn
                                    color="#fff"
                                    block
                                    :to="{name: 'monitor-create'}"
                            >
                                <span class="text-capitalize mr-3" style="color:#000">Add Monitor</span>
                                <v-icon color="#000" right>add</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-list>
                        <template v-for="smonitor in sideBarMonitors">
                            <v-list-group
                                    v-model="smonitor.model"
                                    :key="smonitor.monitor_uuid"
                            >
                                <v-list-tile slot="activator" class="list-fix">
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            <span :title="smonitor.name" class="zawgyi body-2 font-weight-regular">{{ smonitor.name | unescapeString }}</span>
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <span
                                            v-if="!!smonitor.type"
                                            class="custom-chip custom-chip--fill font-weight-bold">
                                        {{ smonitor.type === 'keyword' ? "BUZZ" : smonitor.type.toUpperCase() }}
                                    </span>
                                </v-list-tile>
                                <v-list-tile
                                        v-for="(item,index) in smonitor.children"
                                        :key="index + smonitor.monitor_uuid"
                                        :to="item.url"
                                        style="color: #959DA7;">
                                    <v-list-tile-action>
                                        <v-img
                                                width="13"
                                                height="13"
                                                contain
                                                :src="require(`@/assets/${item.src}`)"
										>
                                        </v-img>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            <span class="body-2 font-weight-regular">{{ item.name}}</span>
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <span class="custom-chip custom-chip--light font-weight-bold" v-if="item.isBeta">BETA</span>
                                </v-list-tile>
                            </v-list-group>
                        </template>
                    </v-list>
                    <div class="text-xs-center">
                        <v-btn
                                :to="{name:'monitor-list'}"
                                :ripple="false"
                                color="#445163"
                                v-show="$route.name !== 'monitor-list' "
                                large
                                depressed
                        >
                            <span class="text-capitalize">Show More</span>
                        </v-btn>
                    </div>
                </v-flex>
                <v-flex v-if="!authenticatedUser.is_user" class="text-xs-center">
                    <v-layout row fill-height align-end>
                        <v-flex>
                            <v-btn
                                    to="/global-settings"
                                    color="#1E2B3B"
                                    :ripple="false"
                                    dark
                            >
                                <span class="text-capitalize">Settings</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-navigation-drawer>
        <v-toolbar :dense="isDense" app color="#fff">
            <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title class="hidden-md-and-down">
                <span class="zawgyi toolbar-title--color mr-2 subheading">{{ monitorTitle | unescapeString}}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-if="$route.name === 'comparison' || $route.name === 'mention' || $route.name === 'sentiment'">
                <div class="d-flex" style="width:290px;">
                    <el-date-picker
							style="border-radius: 0;"
                            size="mini"
                            v-model="selectedDate"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="To"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            :picker-options="dateOptions"
                            :disabled="!monitorActionReady"
                            @change="pickDate"
                    >
                    </el-date-picker>
                </div>
                <v-divider vertical inset class="ml-2"></v-divider>
            </template>
            <v-toolbar-items>
                <template v-if="$route.name === 'mention' || $route.name === 'sentiment'">
                    <!-- :disabled="!isReportLoading" -->
                    <v-btn @click="reportDialogStatus = true" flat>
                        <v-img v-show="true" :src="require('@/assets/downloadicon.svg')" height="14" width="14" contain></v-img>
                        <span class="text-capitalize caption">Export</span>
                    </v-btn>
                    <v-divider vertical inset></v-divider>
                </template>
                <v-menu
                        :nudge-width="200"
                        :close-on-content-click="false"
                        offset-y
                        v-model="dropDown"
                >
                    <template slot="activator">
                        <v-btn flat small>
                            <v-icon size="25">account_circle</v-icon>
                            <span class="mx-1 caption text-capitalize">{{authenticatedUser !== undefined ? authenticatedUser.name : 'User'}}</span>
                            <v-icon size="15">keyboard_arrow_down</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-list two-line>
                            <v-list-tile avator>
                                <v-list-tile-avatar>
                                    <v-icon size="35">account_circle</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{authenticatedUser !== undefined ? authenticatedUser.name : 'User'}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>
                                        <span @click="changePwdDialogStatus = true" class="add-cursor change-pwd-button">
                                            Change Password
                                        </span>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="signOut()" flat>Logout</v-btn>
                            <v-btn flat @click="dropDown = false">Cancel</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-toolbar-items>
            <template slot="extension" v-if="$route.name === 'comparison'">
                <v-tabs
                    slider-color="bindezcolor"
                    v-model="active"
                >
                    <v-tab @click="scrollChildComponent('#monitors')"><span class="text-capitalize font-weight-bold subheading">Monitors</span></v-tab>
                    <v-tab @click="scrollChildComponent('#keywords')"><span class="text-capitalize font-weight-bold subheading">Keywords</span></v-tab>
                    <v-tab @click="scrollChildComponent('#mentions')"><span class="text-capitalize font-weight-bold subheading">Mentions</span></v-tab>
                    <v-tab @click="scrollChildComponent('#reactions')"><span class="text-capitalize font-weight-bold subheading">Reactions</span></v-tab>
                    <v-tab @click="scrollChildComponent('#sentiments')"><span class="text-capitalize font-weight-bold subheading">Sentiments</span></v-tab>
<!--                    <v-tab @click="scrollChildComponent('#emotions')">Emotions</v-tab>-->
                    <v-tab @click="scrollChildComponent('#topics')"><span class="text-capitalize font-weight-bold subheading">Topics</span></v-tab>
                </v-tabs>
            </template>
        </v-toolbar>
        <v-content>
            <!-- @move="move" -->
            <v-container pt-2 px-3 fluid grid-list-lg>
                <v-alert
                        class="custom-alert"
                        :value="showAlert"
                        @input="showAlert = false"
                        dismissible
                        :color="alertColor"
                >

                    <i :class="alertIcon" class="alert__icon"></i>
                    <span style="margin-left: 20px;" class="subheading font-weight-regular">{{alertMessage}}</span>
                </v-alert>
                <router-view ref="childCompos" v-if="!isOrganizationExpired" :key="$route.path"></router-view>
                <AppOrgExpireAlert :organizationExpiredMsg="organizationExpiredMessage" v-else/>
            </v-container>
            <v-dialog
                    v-model="errorDialog"
                    width="600"
                    persistent
            >
                <v-card>
                    <v-card-text>
                        <div class="d-flex fill-height justify-center align-center">
                            <v-icon
                                    :size="60"
                                    class="mr-4"
                                    color="bindezcolor"
                            >
                                fas fa-exclamation-circle
                            </v-icon>
                            <span class="title font-weight-bold">
                                {{ errorDialogMessage }}
                            </span>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-layout row justify-center>
                            <v-btn
                                    large
                                    outline
                                    color="bindezcolor"
                                    @click="errorDialogAction"
                            >
                                {{errorBtnText}}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog width="675px" v-model="reportDialogStatus">
                <v-card>
                    <v-card-title align-center>
                        <div>
                            <h2 class="title font-weight-bold pb-3" style="color: var(--bindez-green-color);">Export your report</h2>
                            <span>To continue please choose which type of report you want to download</span>
                        </div>
                        <v-icon class="ml-auto align-self-start" @click="reportDialogStatus = false">
                            far fa-times-circle
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="pt-0">
                        <div class="px-5" style="height: 330px;">
                            <v-layout column fill-height justify-space-around>
                                <div>
                                    <v-layout align-start>
                                        <v-flex align-self-center xs2>
                                            <AppExcelLogo/>
                                        </v-flex>
                                        <v-flex xs10 ml-5>
                                            <h3 class="headline font-weight-light mb-2">Excel Report(.XLSX)</h3>
                                            <p>Easily download all the graph data in excel format with Insightful and Informative data</p>
                                            <v-btn :loading="isXlsxReportLoading" @click="generateMonitorReport('Xlsx')" class="mt-0 ml-0" dark depressed color="bindezcolor">
                                                <span class="text-capitalize">Download</span>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </div>
                                <v-divider/>
                                <div>
                                    <v-layout align-center>
                                        <v-flex align-self-center xs2>
                                            <AppPptxLogo/>
                                        </v-flex>
                                        <v-flex xs10 ml-5>
                                            <h3 class="headline font-weight-light mb-2">Presentation Report(.PPTX)</h3>
                                            <p>Quickly create your editable document and share it with your stakeholders in short period of time</p>
                                            <v-btn :loading="isPptxReportLoading" @click="generateMonitorReport('Pptx')" class="mt-0 ml-0" color="bindezcolor" dark depressed>
                                                <span class="text-capitalize">Download</span>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <AppChangePasswordDialog v-model="changePwdDialogStatus"></AppChangePasswordDialog>
        </v-content>
    </v-app>
</template>

<script>
	import {mapActions, mapState, mapMutations} from 'vuex'
	import moment from 'moment'
    import authCurrentUser from '@/mixins/authCurrentUser'
    import _isEmpty from 'lodash/isEmpty';
	import _capitalize from 'lodash/capitalize';
	import AppOrgExpireAlert from "../components/AppOrgExpireAlert";
	import AppExcelLogo from "../components/StaticAssets/AppExcelLogo";
	import AppPptxLogo from "../components/StaticAssets/AppPptxLogo";
	import AppChangePasswordDialog from "../components/AppChangePasswordDialog";


	export default {
        name: "Default",
		components: {AppChangePasswordDialog, AppPptxLogo, AppExcelLogo, AppOrgExpireAlert},
		mixins: [authCurrentUser],
		data() {
			return {
				active: 0,
				url: process.env.VUE_APP_REDIRECT_URL,
				isXlsxReportLoading: false,
				isPptxReportLoading: false,
				drawer: true, /* don't delete */
				toggle: true,
				menu: false,
				dropDown: false,
				items: [],
				dateOptions: {
					shortcuts: [
						{
							text: 'Last 7 days',
							onClick(picker) {
								const end = moment().toDate();
								const start = moment().subtract(6, 'day').toDate();
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: 'Last 30 days',
							onClick(picker) {
								const end = moment().toDate();
								const start = moment().subtract(1, 'month').toDate();
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: 'Last 90 days',
							onClick(picker) {
								const end = moment().toDate();
								const start = moment().subtract(3, 'month').toDate();
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: 'Last 180 days',
							onClick(picker) {
								const end = moment().toDate();
								const start = moment().subtract(6, 'month').toDate();
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: 'Last Week',
							onClick(picker) {
								const end = moment().subtract(1, 'week').endOf('week').toDate();
								const start = moment().subtract(1, 'week').startOf('week').toDate();
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: 'Last Month',
							onClick(picker) {
								const end = moment().subtract(1, 'month').endOf('month').toDate();
								const start = moment().subtract(1, 'month').startOf('month').toDate();
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: 'Last 3 Months',
							onClick(picker) {
								const end = moment().subtract(1, 'month').endOf('month').toDate();
								const start = moment().subtract(3, 'month').startOf('month').toDate();
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: 'Last 6 Months',
							onClick(picker) {
								const end = moment().subtract(1, 'month').endOf('month').toDate();
								const start = moment().subtract(6, 'month').startOf('month').toDate();
								picker.$emit('pick', [start, end]);
							},
						},
					],
					disabledDate: date => !moment(date).isBetween(moment().subtract(6, 'month'), moment().endOf('day')),
				},
				isUserOrgLoading: false,
                reportDialogStatus: false,
                changePwdDialogStatus: false,
			}
		},
		computed: {
            ...mapState({
                rawSideBarMonitor: 'sidebarMonitor',
                monitor:'monitor',
                monitorActionReady: 'monitorActionReady',
                userOrganizationName: state => state.authorizedUserOrganization.name,
                userOrganizationExipresDate: state => moment(state.authorizedUserOrganization.expires_at).format("D MMM YYYY")
            }),

			...mapState('error', [
				'errorDialog',
				'errorDialogMessage',
				'errorStatusCode',
                "errorBtnText",
                "isOrganizationExpired",
                "organizationExpiredMessage"
			]),

			...mapState('comparison', [
				'selectedMonitors',
                'activeSection'
			]),

			...mapState('organizations', [
				"organization"
			]),

			...mapState([
				"alertStatus",
                "alertMessage",
                "alertColor",
                "alertIcon"
			]),

			isDense() {
				return this.$route.name !== 'comparison'
			},

			monitorsToCompare() {
				return [this.$route.params.monitor_uuid, ...this.selectedMonitors.map(monitor => monitor.monitor_uuid)];
			},

			checkRoute() {
				let routes = ["sentiment", "mention", "comparison", "platform", "audience-list", "audience-analysis"];
				return routes.includes(this.$route.name);
			},

			sideBarMonitors() {
				return this.rawSideBarMonitor.map(monitor => {
					return {
						name: monitor.name,
						monitor_uuid: monitor.monitor_uuid,
                        type: monitor.type,
                        model: (monitor.monitor_uuid === this.$route.params.monitor_uuid) && this.checkRoute,
						children: [
							{name: 'Mentions', url: `/mention/${monitor.monitor_uuid}`, src: "Mention.svg"},
							{name: 'Sentiments', url: `/sentiment/${monitor.monitor_uuid}`, src: "Sentiment.svg"},
							{name: 'Audience', url: `/audience/${monitor.monitor_uuid}`, src: "Audience.svg"},
							{name: 'Instagram', isBeta:true, url: `/platform/${monitor.monitor_uuid}/instagram`, src: "Instagram.svg"},
							{name: 'TikTok', isBeta:true, url: `/platform/${monitor.monitor_uuid}/tiktok`, src: "Tiktok.svg"},
							{name: 'Youtube', isBeta:true, url: `/platform/${monitor.monitor_uuid}/youtube`, src: "Youtube.svg"},
							{name: 'Forum', isBeta:true, url: `/platform/${monitor.monitor_uuid}/forum`, src: "Forum.svg"},
                            {name: 'Comparison', url:`/compare/${monitor.monitor_uuid}`, src: "Comparison.svg"},
							{name: 'Settings', url: `/monitor/${monitor.monitor_uuid}/edit`, src: "Settings.svg"}
						]
					}
				})
			},

			monitorTitle() {
				let routeName = this.$route.name;
				let titles = {'comparison': 'Comparison','monitor-create': 'Create New Monitor', 'monitor-list': 'Monitor List', 'audience-list': 'Audience', 'audience-analysis': 'Audience'};
				let analytic = ['mention', 'sentiment', 'postdetail'];
				if (analytic.includes(routeName)) {
					return this.monitor ? this.monitor.name : '';
				} else if (routeName === 'platform') {
					return _capitalize(this.$route.params.platform);
				} else {
					return titles[routeName];
				}
			},

			selectedDate: {
				get() {
					return this.$store.state.selectedDate
				},
				set(value) {
					let startDate = value ? moment(value[0]).format("YYYY-MM-DD") : moment().subtract(3,'month').format('YYYY-MM-DD');
					let endDate = value ? moment(value[1]).format("YYYY-MM-DD") : moment().format('YYYY-MM-DD');
					this.$store.commit('setSelectedDates', [startDate, endDate]);
				}
			},

			showAlert: {
				get() {
					return this.alertStatus
				},
				set(status) {
					this.setAlertStatus(status)
				}
			}
		},
		methods: {
			...mapActions('mention', [
				'fetchMonitorFacebookPosts',
                'fetchMonitorFanCount'
			]),

			...mapActions('sentiment', [
				'fetchMonitorAllComments'
			]),

			...mapActions([
				'fetchFacebookSummary',
				'logout',
				'generateReport',
                'fetchSidebarMonitors',
                'fetchEngagementStats',
                'fetchAuthorizedUserOrg'
			]),

			...mapActions('comparison', [
				'fetchMentionComparisonMetric',
				'fetchSentimentComparisonMetric',
				'fetchReactionComparisonMetric',
				'fetchKeywordsComparisonMetric',
			]),

			...mapMutations([
				'setSideBarMonitor',
                'setMonitorActionReady',
                'setEngagementStats',
                'setEngagementReady',
                'setAlertStatus',
			]),

			...mapMutations('comparison', [
                'setDefaultState',
                'setComparisonReady'
			]),

			...mapMutations('mention', [
				'setDefaultMentionState',
				'setPostReady',
				'setSummaryReady',
				'setMentionPageReady',
			]),

			...mapMutations('sentiment', [
				'setCommentReady',
                'setSentimentPageReady',
                'setDefaultSentimentState'
			]),

			...mapMutations('error', [
				'setErrorDialogDefaultState',
                'setErrorDialogStatus'
			]),

			pickDate() {
				this.$ua.trackEvent("Select Date Range", "select", `${this.authenticatedUser.email || 'User'} select monitor(${this.monitor.monitor_uuid})'s date from ${this.selectedDate[0]} to ${this.selectedDate[1]}`);
                //clear old keyword and topmention after selecting date
                this.setDefaultMentionState();

				//clear old sentiment, tags, folder  after selecting date
                this.setDefaultSentimentState();

                //update all posts, cmts and summary after picking data.
				this.setSummaryReady(false);

				this.setPostReady(false);
				this.setCommentReady(false);
				this.setMonitorActionReady(false);
				this.setEngagementReady(false);

				this.setComparisonReady(false);

                let comparePayload = {monitor_uuids: this.monitorsToCompare, timerange: this.selectedDate};
                let payload = {monitor_uuid: this.$route.params.monitor_uuid, timerange: this.selectedDate};
				Promise.all([
                    //fetch all comparison metric
					this.fetchSentimentComparisonMetric(comparePayload),
					this.fetchReactionComparisonMetric(comparePayload),
					this.fetchMentionComparisonMetric(comparePayload),
					this.fetchKeywordsComparisonMetric({monitor_uuids: this.monitorsToCompare}),

					this.fetchFacebookSummary(payload),
					this.fetchMonitorFacebookPosts(payload),
					this.fetchMonitorAllComments(payload),
                    this.fetchEngagementStats({monitor_uuid: this.$route.params.monitor_uuid, timerange: this.selectedDate}),
					this.fetchMonitorFanCount({monitor_uuid: this.$route.params.monitor_uuid}),
				]).then(() => {
					// this.$refs.childCompos.updateSuggestedMaxValue();

					this.setSummaryReady(true);
					this.setPostReady(true);
					this.setCommentReady(true);
					this.setMonitorActionReady(true);
					this.setComparisonReady(true);

					//after picking date mention and sentiment page should disable loading
					this.setMentionPageReady(true);
					this.setSentimentPageReady(true);
					this.setEngagementReady(true);
				});
			},

			signOut() {
				this.$ua.trackEvent("Sign Out", "click");
				this.logout().then(() => {
					this.$session.destroy();
					document.cookie = "connect.sid=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
					window.location.href = `${this.url}/login`;
				})
			},

			generateMonitorReport(type) {
				let loadingType = `is${type}ReportLoading`;
				this[loadingType] = true;
				type = type.toLowerCase();
				this.$ua.trackEvent("Monitor Report", "click", `Export ${this.monitor && this.monitor.name} Report by ${this.authenticatedUser.email}`);
				this.generateReport({
					data: {monitor_uuid: this.monitor.monitor_uuid, timerange: this.selectedDate},
					type
				})
					.then((res) => {
						let blob = res.data;
						let filename = this.monitor.name + res.headers['content-disposition'].split(';')[1].split("=")[1];
						let link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.download = filename;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.reportDialogStatus = false;
					})
					.finally(_ => {
						this[loadingType] = false;
					})
				;
			},

			addMonitorToSidebar() {
				let foundMonitor = this.rawSideBarMonitor.find(rmonitor => rmonitor.monitor_uuid === this.monitor.monitor_uuid);

				if (!_isEmpty(this.rawSideBarMonitor)) {
					if (!_isEmpty(this.monitor) &&
						(this.$route.name === 'postdetail' || this.$route.name === 'mention' || this.$route.name === 'sentiment') &&
						!foundMonitor
					) {
						this.setSideBarMonitor([this.monitor, ...this.rawSideBarMonitor.slice(0, 2)]);
					}
				}
			},

            scrollChildComponent(sectionId){
				this.$refs.childCompos.scrollSection(sectionId);
            },

			errorDialogAction() {
				switch (this.errorStatusCode) {
					case 401:
						localStorage.clear();
						console.log("here");
						window.location.href = `${this.url}/login`;
						break;
					case 500:
						this.$router.push({name: 'monitor-list'});
						break;
					default:
						this.setErrorDialogStatus(false);
						break;
				}
				this.setErrorDialogDefaultState();
			},
		},

		created() {
			if(this.$route.name !== 'monitor-list') this.fetchSidebarMonitors();
			this.isUserOrgLoading = true ;
			this.fetchAuthorizedUserOrg().then(_ => this.isUserOrgLoading = false);
		},

		watch: {
			monitor: 'addMonitorToSidebar',
            rawSideBarMonitor: 'addMonitorToSidebar',
            activeSection:{
				handler(val){
					this.active = val;
                },
                immediate: true
            },
            '$route.name':{
				handler(val){
					this.drawer = val !== 'audience-analysis';
                }
            }
		},

	}
</script>

<style scoped>
    .text-color {
        color: #fff;
    }

    .list-fix {
        flex: 1 1 auto !important;
        overflow: hidden;
        /*padding-right: 10px;*/
    }

    .custom-chip{
        border-radius: 2px;
        display: inline-block;
        width: auto;
        height:auto;
        padding: 2px;
        margin-left: auto;
        font-size: 0.64rem;
    }

    .custom-chip--fill{
        color: #fff;
        background-color: var(--bindez-green-color);
    }

    .custom-chip--light{
        color: #fff;
        border: 1px solid var(--bindez-green-color);
    }

    /*deeply select the list item */
    .list-fix >>> .v-list__tile {
        padding-right: 0px;
    }

    .change-pwd-button{
        margin-top: 4px;
        display: inline-block;
        padding: 4px 6px;
        color: var(--bindez-light-grey-color);
        border: 1px solid var(--bindez-light-grey-color);
        border-radius: 20px;
    }

    .custom-alert{
        border-radius: 5px;
    }

    .alert__icon{
        font-size: 20px;
        background-color: var(--bindez-green-color);
        padding: 5px;
        border-radius: 4px;
    }
</style>
